<template>
  <div
    v-loading="loading"
    class="my-com"
  >
    <el-container class="common-container">
      <el-main class="main">
        <div class="form-title">
          <span>
            我的企业
          </span>
        </div>
        <div class="form">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            :rules="rules"
          >
            <el-form-item
              label="轮播图"
              prop="slideShow"
            >
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div>
                只能上传jpg/png文件，每张不超过2M，最多支持5张图片
              </div>
            </el-form-item>
            <el-form-item
              label="企业介绍"
              prop="introduction"
            >
              <mk-input
                v-model="form.introduction"
                type="textarea"
                resize="none"
                height="68"
                width="520"
                placeholder="输入企业文字介绍"
              ></mk-input>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <el-footer
        class="button-footer"
        height="56"
      >
        <el-button
          type="primary"
          size="small"
          @click="saveBasicInfo"
        >
          保存
        </el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'MyCom',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          slideShow: [],
          introduction: '',
          isActive: true
        }
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: {
        slideShow: [],
        introduction: '',
        isActive: true
      },
      rules: {},
      loading: false
    }
  },
  watch: {
    formData (newVal, oldVal) {
      this.form = this._.cloneDeep(newVal)
    }
  },
  methods: {
    // 保存信息
    saveBasicInfo () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          let res = await JINGTUIAPIS.CardApi.cardPut(
            {
              id: this.id
            },
            {
              company: this.form
            }
          )
          this.loading = false
          if (res.success) {
            this.$message.success('保存成功')
            this.form = res.data[0].company
          }
        } else {
          this.$message.error('有必填项未填写')
          return false
        }
      })
    },
    handlePictureCardPreview () {},
    handleRemove () {}
  }
}
</script>

<style lang="scss" scoped>
.my-com {
  background-color: #fff;
  width: 100%;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form {
    margin-top: 30px;
  }

  // /deep/ .el-upload--picture-card {
  //   width: 60px;
  //   height: 60px;
  // }
}
</style>
